/**
 * The OTA prompt on the web, which is nothing at all.
 *
 * ---------------------------------------------------------------------------
 * THERE IS NO STALE BUNDLE IN A BROWSER
 * ---------------------------------------------------------------------------
 * `expo-updates` exists to swap a JS bundle that is already installed on a
 * phone. A browser has no installed bundle: it fetches the current one from
 * the server on every load, and the deploy that publishes a new build IS the
 * update. So there is never anything staged to offer, and a prompt asking
 * somebody to restart into a version they are already running would be a
 * modal about nothing.
 *
 * The file also has to exist for a second reason. `expo-updates` drags in
 * `expo-modules-core`, whose type declarations break the web bundle at BUILD
 * time - the native module has nowhere to bind in a browser. Resolving this
 * twin ahead of `OtaUpdateGate.tsx` keeps the import out of the web graph
 * entirely rather than stubbing it after the fact.
 *
 * The props are copied verbatim from the native component so `App.tsx` stays
 * one file for both platforms.
 */

type Props = {
  /** Honoured on the phone; there is no prompt here to hold back. */
  suppressed?: boolean;
};

function OtaUpdateGate(_props: Props) {
  return null;
}

export default OtaUpdateGate;
